/**
 * UserStatus.js
 * Talkroute
 *
 * Created by Vel Genov on 12/24/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";

import uiString from "../constants/uiString";

interface IUserStatusProps {
  status: string;
}

/**
 * Displays an icon indicating call status
 * For users that are online, the icon is green
 */
class UserStatus extends React.Component<IUserStatusProps, any> {
  render() {
    const { status } = this.props;
    let className = "status-on-line";
    switch (status) {
      case uiString.callStatus.ONLINE:
        className = "status-on-line";
        break;
      default:
        className = "status-on-line";
        break;
    }

    return (
      <div
        className={className}
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
        }}
      />
    );
  }
}

export default UserStatus;
